<template>
  <svg
    id="Duotone"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 100 112">
    <g id="Icons">
      <g id="Background">
        <path
          class="cls-2"
          d="M90,56A40,40,0,1,0,13.56,72.5H86.44A39.85,39.85,0,0,0,90,56Z" />
        <line
          class="cls-3"
          x1="11"
          y1="72.5"
          x2="89"
          y2="72.5" />
        <line
          class="cls-3"
          x1="6.5"
          y1="72.5"
          x2="9"
          y2="72.5" />
        <line
          class="cls-3"
          x1="91"
          y1="72.5"
          x2="93.5"
          y2="72.5" />
      </g>
      <g id="Scene">
        <path
          class="cls-4"
          d="M43.2,34.73a1.42,1.42,0,0,0-1.15-1.38v-.92a6.9,6.9,0,0,0-13.8,0v.92a1.41,1.41,0,0,0,.14,2.79,6.91,6.91,0,0,0,13.52,0A1.43,1.43,0,0,0,43.2,34.73Z" />
        <path
          class="cls-5"
          d="M27.67,65.21v20.7h5.18l.55-13.74a1.75,1.75,0,1,1,3.5,0l.55,13.74h5.18V65.21Z" />
        <path
          class="cls-3"
          d="M27.67,65.21v20.7h5.18l.55-13.74a1.75,1.75,0,1,1,3.5,0l.55,13.74h5.18V65.21Z" />
        <ellipse
          class="cls-2"
          cx="35.15"
          cy="87.06"
          rx="14.95"
          ry="1.73" />
        <path
          class="cls-4"
          d="M32.06,86.48a1.15,1.15,0,0,0,1-1.72,3.45,3.45,0,0,0-3-1.73h-.58a3.45,3.45,0,0,0-3,1.73,1.15,1.15,0,0,0,1,1.72Z" />
        <path
          class="cls-4"
          d="M38.24,86.48a1.15,1.15,0,0,1-1-1.72,3.45,3.45,0,0,1,3-1.73h.58a3.45,3.45,0,0,1,3,1.73,1.15,1.15,0,0,1-1,1.72Z" />
        <path
          class="cls-4"
          d="M42.63,46.69a11.52,11.52,0,0,0-15,0V65.21h15Z" />
        <path
          class="cls-4"
          d="M35.15,43.93a11.41,11.41,0,0,0-4.11.76c.84,1.62,2.57,3.27,4.11,3.27s3.27-1.65,4.11-3.27A11.41,11.41,0,0,0,35.15,43.93Z" />
        <path
          class="cls-6"
          d="M23.65,55.43v5a1.9,1.9,0,0,1-3.66.71,2,2,0,0,0-3.6,1.8,5.89,5.89,0,0,0,5.36,3.42,5.78,5.78,0,0,0,5.92-5.75V72.68H29a1.15,1.15,0,0,0,1.13-.94C31.74,63.3,32,53.55,31.68,44.47A11.49,11.49,0,0,0,23.65,55.43Z" />
        <path
          class="cls-4"
          d="M20,61.14a2,2,0,0,0-3.6,1.8,6.72,6.72,0,0,0,1.2,1.7l3.23-2.55A2.19,2.19,0,0,1,20,61.14Z" />
        <line
          class="cls-3"
          x1="27.67"
          y1="53.13"
          x2="27.67"
          y2="60.61" />
        <path
          class="cls-3"
          d="M23.65,55.43v5a1.9,1.9,0,0,1-3.66.71,2,2,0,0,0-3.6,1.8,5.89,5.89,0,0,0,5.36,3.42,5.78,5.78,0,0,0,5.92-5.75V72.68H29a1.15,1.15,0,0,0,1.13-.94C31.74,63.3,32,53.55,31.68,44.47A11.49,11.49,0,0,0,23.65,55.43Z" />
        <path
          class="cls-6"
          d="M46.65,55.43v5a1.9,1.9,0,0,0,3.66.71,2,2,0,0,1,3.6,1.8,5.89,5.89,0,0,1-5.36,3.42,5.78,5.78,0,0,1-5.92-5.75V72.68H41.27a1.15,1.15,0,0,1-1.13-.94c-1.58-8.44-1.85-18.19-1.52-27.27A11.49,11.49,0,0,1,46.65,55.43Z" />
        <path
          class="cls-4"
          d="M50.31,61.14a2,2,0,0,1,3.6,1.8,6.72,6.72,0,0,1-1.2,1.7l-3.23-2.55A2.19,2.19,0,0,0,50.31,61.14Z" />
        <line
          class="cls-3"
          x1="42.63"
          y1="53.13"
          x2="42.63"
          y2="60.61" />
        <path
          class="cls-3"
          d="M46.65,55.43v5a1.9,1.9,0,0,0,3.66.71,2,2,0,0,1,3.6,1.8,5.89,5.89,0,0,1-5.36,3.42,5.78,5.78,0,0,1-5.92-5.75V72.68H41.27a1.15,1.15,0,0,1-1.13-.94c-1.58-8.44-1.85-18.19-1.52-27.27A11.49,11.49,0,0,1,46.65,55.43Z" />
        <path
          class="cls-4"
          d="M49.28,78.39a1.15,1.15,0,0,1-1.35,1L45.77,79a1.15,1.15,0,0,1-.91-1.39l2.61-11.21a1.14,1.14,0,0,1,1.33-.87l1.22.23A1.15,1.15,0,0,1,51,67Z" />
        <line
          class="cls-3"
          x1="49.41"
          y1="66.8"
          x2="50.8"
          y2="59.46" />
        <path
          class="cls-4"
          d="M56.2,79.36,58.36,79a1.14,1.14,0,0,0,.91-1.39l-2.6-11.21a1.15,1.15,0,0,0-1.34-.87l-1.22.23a1.14,1.14,0,0,0-.92,1.3l1.66,11.38A1.15,1.15,0,0,0,56.2,79.36Z" />
        <line
          class="cls-3"
          x1="54.72"
          y1="66.8"
          x2="53.34"
          y2="59.46" />
        <path
          class="cls-4"
          d="M54.32,78.38a1.16,1.16,0,0,1-1.15,1.2H51a1.14,1.14,0,0,1-1.15-1.2l.48-11.5a1.14,1.14,0,0,1,1.14-1.1h1.25a1.16,1.16,0,0,1,1.15,1.1Z" />
        <line
          class="cls-3"
          x1="52.07"
          y1="66.99"
          x2="52.07"
          y2="59.51" />
        <path
          class="cls-4"
          d="M22.37,79.36,24.53,79a1.15,1.15,0,0,0,.91-1.39L22.83,66.35a1.14,1.14,0,0,0-1.33-.87l-1.22.23a1.15,1.15,0,0,0-.93,1.3L21,78.39A1.15,1.15,0,0,0,22.37,79.36Z" />
        <line
          class="cls-3"
          x1="20.89"
          y1="66.8"
          x2="19.5"
          y2="59.46" />
        <path
          class="cls-4"
          d="M14.1,79.36,11.94,79A1.14,1.14,0,0,1,11,77.56l2.6-11.21A1.15,1.15,0,0,1,15,65.48l1.22.23a1.14,1.14,0,0,1,.92,1.3L15.45,78.39A1.15,1.15,0,0,1,14.1,79.36Z" />
        <line
          class="cls-3"
          x1="15.58"
          y1="66.8"
          x2="16.96"
          y2="59.46" />
        <path
          class="cls-4"
          d="M17.13,79.58h2.21a1.14,1.14,0,0,0,1.14-1.2L20,66.88a1.14,1.14,0,0,0-1.14-1.1H17.61a1.16,1.16,0,0,0-1.15,1.1L16,78.38A1.16,1.16,0,0,0,17.13,79.58Z" />
        <line
          class="cls-3"
          x1="18.23"
          y1="66.99"
          x2="18.23"
          y2="59.51" />
        <path
          class="cls-4"
          d="M35.15,39.91c-3.06,0-5.18-.58-6.55-3,0,4.83,4.41,7.73,6,8.62a1.15,1.15,0,0,0,1.12,0c1.58-.89,5.95-3.79,6-8.62C40.33,39.33,38.21,39.91,35.15,39.91Z" />
        <path
          class="cls-6"
          d="M34.74,22.49a.59.59,0,0,1,.8,0c1.47,1.43,1.86.68,3.05,2.35a3.71,3.71,0,0,1,.52,2.75,2.29,2.29,0,0,1-2,1.94,16.89,16.89,0,0,1-2,.14,16.89,16.89,0,0,1-2-.14,2.27,2.27,0,0,1-2-1.94,3.75,3.75,0,0,1,.51-2.75C32.88,23.17,33.27,23.92,34.74,22.49Z" />
        <path
          class="cls-3"
          d="M34.74,22.49a.59.59,0,0,1,.8,0c1.47,1.43,1.86.68,3.05,2.35a3.71,3.71,0,0,1,.52,2.75,2.29,2.29,0,0,1-2,1.94,16.89,16.89,0,0,1-2,.14,16.89,16.89,0,0,1-2-.14,2.27,2.27,0,0,1-2-1.94,3.75,3.75,0,0,1,.51-2.75C32.88,23.17,33.27,23.92,34.74,22.49Z" />
        <rect
          class="cls-5"
          x="29.62"
          y="33.01"
          width="4.14"
          height="2.88"
          rx="1"
          ry="1" />
        <path
          class="cls-6"
          d="M32.61,33H30.77a1.15,1.15,0,0,0-1.15,1.15v.57a1.14,1.14,0,0,0,.53,1L32.83,33A.78.78,0,0,0,32.61,33Z" />
        <rect
          class="cls-3"
          x="29.62"
          y="33.01"
          width="4.14"
          height="2.88"
          rx="1.15"
          ry="1.15" />
        <rect
          class="cls-5"
          x="36.54"
          y="33.01"
          width="4.14"
          height="2.88"
          rx="1"
          ry="1" />
        <path
          class="cls-6"
          d="M39.53,33H37.69a1.14,1.14,0,0,0-1.15,1.15v.57a1.14,1.14,0,0,0,.53,1L39.75,33A.82.82,0,0,0,39.53,33Z" />
        <rect
          class="cls-3"
          x="36.54"
          y="33.01"
          width="4.14"
          height="2.88"
          rx="1.15"
          ry="1.15" />
        <line
          class="cls-3"
          x1="36.54"
          y1="34.16"
          x2="33.76"
          y2="34.16" />
        <path
          class="cls-4"
          d="M37.63,38.76a5.21,5.21,0,0,0,3.27,2.06.11.11,0,0,1,0,.22c-1.08.4-4.32,1.39-5.53-.67a1.44,1.44,0,0,1,.32-1.93A1.35,1.35,0,0,1,37.63,38.76Z" />
        <path
          class="cls-4"
          d="M32.67,38.76a5.21,5.21,0,0,1-3.27,2.06.11.11,0,0,0,0,.22c1.08.4,4.32,1.39,5.53-.67a1.44,1.44,0,0,0-.32-1.93A1.35,1.35,0,0,0,32.67,38.76Z" />
        <g class="cls-7">
          <rect
            class="cls-8"
            x="60.5"
            y="15.5"
            width="52"
            height="57" />
          <rect
            class="cls-5"
            x="79.5"
            y="39"
            width="14"
            height="25"
            rx="1"
            ry="1" />
          <path
            class="cls-6"
            d="M93.5,45.5l-14,14V40a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1Z" />
          <rect
            class="cls-3"
            x="79.5"
            y="39"
            width="14"
            height="25"
            rx="1"
            ry="1" />
          <rect
            class="cls-8"
            x="60.5"
            y="36.5"
            width="16"
            height="36" />
          <rect
            class="cls-8"
            x="59.5"
            y="65.5"
            width="19"
            height="3"
            rx="1"
            ry="1" />
          <line
            class="cls-3"
            x1="62.5"
            y1="70.5"
            x2="74.5"
            y2="70.5" />
          <rect
            class="cls-5"
            x="63"
            y="39"
            width="11"
            height="24"
            rx="1"
            ry="1" />
          <path
            class="cls-6"
            d="M73,39H64a1,1,0,0,0-1,1V55.5L74,45V40A1,1,0,0,0,73,39Z" />
          <rect
            class="cls-3"
            x="63"
            y="39"
            width="11"
            height="24"
            rx="1"
            ry="1" />
          <rect
            class="cls-8"
            x="96.5"
            y="36.5"
            width="16"
            height="36" />
          <rect
            class="cls-8"
            x="95.5"
            y="65.5"
            width="19"
            height="3"
            rx="1"
            ry="1" />
          <line
            class="cls-3"
            x1="98.5"
            y1="70.5"
            x2="110.5"
            y2="70.5" />
          <rect
            class="cls-5"
            x="99"
            y="39"
            width="11"
            height="24"
            rx="1"
            ry="1" />
          <path
            class="cls-6"
            d="M109,39h-9a1,1,0,0,0-1,1V55.5L110,45V40A1,1,0,0,0,109,39Z" />
          <rect
            class="cls-3"
            x="99"
            y="39"
            width="11"
            height="24"
            rx="1"
            ry="1" />
          <rect
            class="cls-8"
            x="80.5"
            y="66.5"
            width="12"
            height="4"
            rx="1"
            ry="1" />
          <rect
            class="cls-4"
            x="57.5"
            y="15.5"
            width="58"
            height="9"
            rx="1"
            ry="1" />
          <polygon
            class="cls-4"
            points="112.5 29.5 60.5 29.5 56.5 36.5 116.5 36.5 112.5 29.5" />
          <path
            class="cls-4"
            d="M116.5,39A3.88,3.88,0,0,1,113,43a3.73,3.73,0,0,1-3.5-2,.49.49,0,0,0-.88,0,3.76,3.76,0,0,1-6.64,0,.48.48,0,0,0-.86,0,3.76,3.76,0,0,1-6.64,0,.48.48,0,0,0-.86,0,3.76,3.76,0,0,1-6.64,0,.48.48,0,0,0-.86,0,3.76,3.76,0,0,1-6.64,0,.48.48,0,0,0-.86,0,3.76,3.76,0,0,1-6.64,0,.48.48,0,0,0-.86,0,3.76,3.76,0,0,1-6.64,0,.49.49,0,0,0-.88,0,3.73,3.73,0,0,1-3.5,2,3.88,3.88,0,0,1-3.55-4V36.5h60Z" />
        </g>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" scoped>
  @use '@/styles/variables' as *;

  .cls-1,
  .cls-3 {
    fill: none;
  }

  .cls-2 {
    fill: var(--iconColorFaded9);
  }

  .cls-3,
  .cls-4,
  .cls-8 {
    stroke: var(--iconColor);
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .cls-4,
  .cls-6 {
    fill: #fff;
  }

  .cls-5,
  .cls-8 {
    fill: var(--iconColorFaded6);
  }
</style>
